import { PurchasedItem, PurchasedItemType } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";

export { default } from "./MessageAttachmentView.vue";
export const selector = (item: PurchasedItem): boolean => {
  return item.subject.subjectType === PurchasedItemType.MESSAGE_ATTACHMENT;
};
